import React from 'react';

export const useCarouselIds = (
    carouselId: string,
    captions?: React.ReactNode[]
) => {
    const formatPanelId = React.useCallback(
        (index: number): string => `${carouselId}-panel-${index}`,
        [carouselId]
    );

    const formatTabId = React.useCallback(
        (index: number): string => `${carouselId}-tab-${index}`,
        [carouselId]
    );

    const formatCaptionId = React.useCallback(
        (index: number, asReference?: boolean): string => {
            const captionId = `${carouselId}-caption-${index}`;
            return !asReference || captions?.[index] ? captionId : '';
        },
        [carouselId, captions]
    );

    return {
        formatPanelId,
        formatTabId,
        formatCaptionId
    };
};
